let gtmScript: HTMLScriptElement | null = null;
// let rumScript: HTMLScriptElement | null = null;

export function injectGTM(containerId: string) {
    // if (gtmScript || rumScript) return; // Avoid duplicates

    if (process.env.NODE_ENV != 'production' || gtmScript) return; // Only inject in production, avoid duplicates

    // Adobe RUM external script
    // rumScript = document.createElement('script');
    // rumScript.defer = true;
    // rumScript.type = 'text/javascript';
    // rumScript.src = '/.rum/@adobe/helix-rum-js@%5E2/dist/rum-standalone.js';
    // document.head.appendChild(rumScript);

    // GTM inline script
    gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${containerId}');
    `;
    
    document.head.appendChild(gtmScript);
}

export function removeGTM() {
    if (gtmScript) {
        document.head.removeChild(gtmScript);
        gtmScript = null;
    }

    // if (rumScript) {
    //     document.head.removeChild(rumScript);
    //     rumScript = null;
    // }

    // Optionally reset dataLayer
    window.dataLayer = [];
}